import React from 'react'
import { SafeSEO } from './SafeSEO'

export function AppFallbackSEO() {
  return (
    <SafeSEO
      title="Keep your child safer on their iPhone | Joey"
      description="AI Smart Alerts for parents. Joey spots bullying, risky contacts, money asks and safety risks across iMessage, Google, YouTube, WhatsApp and SnapChat — no spyware."
      url="https://www.joeyfamily.com/"
      image="https://www.joeyfamily.com/img/og/open_graph.png"
      appendBrand={false}
      ogType="website"
      keywords={[]}
    />
  )
}
